import {EntitySelectComponent} from './item-select.component';
import { Component, forwardRef, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {PageResponse} from '../../models/page-response';
import {Company} from '../../models/company';
import {ProjectRelationService} from '../../services/project-relation.service';

@Component({
    selector: 'app-mdm-company-select',
    templateUrl: './item-select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MdmCompanySelectComponent),
            multi: true
        }
    ],
    standalone: false
})
export class MdmCompanySelectComponent extends EntitySelectComponent<Company, {}> {
    private projectRelationService = inject<ProjectRelationService>('ProjectRelationService' as any);

    constructor() {
        super();
    }

    getLabelText(item: Company): string {
        return item.city ? `${item.companyName} (${item.city})` : item.companyName;
    }

    loadMorePages(page: number, filter: { term: string }): Observable<PageResponse<Company>> {
        return this.projectRelationService.listMdmCompanies(filter.term, page);
    }
}
